// App.js
import "./index.css";
import {
  createBrowserRouter,
  RouterProvider,
  Navigate,
} from "react-router-dom";
import ProtectedRoute from "./components/ProtectedRoute";
import Client from "./components/clientHome/Client";
import EditProfile from "./components/EditProfile";
import PetListings from "./components/PetListings";
// import Invoice from "./components/Invoice";
import Review from "./components/Review";
import Chatpage from "./components/Chatpage";
import Scheduling from "./components/Scheduling";
import Login from "./Page/Login";
import { ToastContainer } from "react-toastify";
import { CartProvider } from "./context/CartContext";
import "react-toastify/dist/ReactToastify.css";
import MappingRouter from "./Mapping/MappingRouter";
import MappingHome from "./Mapping/pages/MappingHome/MappingHome";
import ShopDetail from "./Mapping/pages/ShopDetail/ShopDetail";
import PublicUserForm from "./Mapping/pages/PublicUserForm";
import Forms from "./Mapping/pages/Forms/Forms";
import CardInfo from "./Mapping/pages/CardInfo/CardInfo";
import Confirm from "./Mapping/pages/Confirm/Confirm";
import ProfileCustomer from "./Mapping/pages/ProfileCustomer/ProfileCustomer";
import MappingHeader from "./Mapping/pages/Header/MappingHeader";
import VendorDetail from "./Mapping/pages/VendorDetail/VendorDetail";
import { SearchProvider } from "./context/SearchContext";
import { Provider } from "react-redux";
import { store } from "../src/store/store";
import { Profilepage } from "./Mapping/pages/Profilepage/Profilepage";
import Petsection from "./Mapping/pages/Petsection/Petsection";
import Appointment from "./Mapping/pages/TabProfile/Appointment";
import { Appointmentpage } from "./Mapping/pages/Appointmentpage/Appointmentpage";
import PaymentPage from "./Mapping/pages/PaymentPage/PaymentPage";
import { RecordsLayout } from "./Mapping/pages/Records/RecordsLayout";
import { Chats } from "./Mapping/pages/Records/Chats";
import { Profilesectionpage } from "./Mapping/pages/Profilesectionpage/Profilesectionpage";
import { PetDetails } from "./Mapping/pages/PetDetails/PetDetails";
import { Bookinglist } from "./components/Bookinglist/Bookinglist";
import Petlisting from "./components/petlisting/petlisting";
import { Invoice } from "./components/Invoice/Invoice";
import Contact from "./components/Contact/Contact";
import { Diary } from "./components/Diary/Diary";
import InvoiceLink from "./components/Invoice/InvoiceLink";
import { ProfileProvider } from "./context/ProfileContext";
import ConsentForm from "./Page/ConsentForm";

const router = createBrowserRouter([
  {
    path: "/invoices/:token",
    element: <InvoiceLink />,
  },
  // Public routes
  {
    path: "/",
    element: (
      <>
        <MappingHeader />

        <MappingHome />
      </>
    ),
  },
  {
    path: "/confirm",
    element: (
      <>
        <MappingHeader />
        <Confirm />
      </>
    ),
  },

  {
    path: "/payment",
    element: (
      <>
        <MappingHeader />

        <PaymentPage />
      </>
    ),
  },

  {
    path: "/shop-detail",

    element: (
      <>
        <MappingHeader />

        <ShopDetail />
      </>
    ),
  },
  {
    path: "/contact",

    element: (
      <>
        <PublicUserForm />
      </>
    ),
  },
  {
    path: "/form/:vendorId/:formId",

    element: (
      <>
        <Forms />
      </>
    ),
  },

  {
    path: "/:token/:nameCompany",

    element: (
      <>
        <MappingHeader />

        <CardInfo />
      </>
    ),
  },

  {
    path: "/vendor-detail/:vendorId",

    element: (
      <>
        <MappingHeader />

        <VendorDetail />
      </>
    ),
  },
  {
    path: "/login",
    element: <Login />,
  },

  {
    path: "/edit-profile",
    element: (
      <>
        <MappingHeader />
        <Profilepage />
      </>
    ),
  },

  {
    path: "/appointments",
    element: (
      <>
        <MappingHeader />
        <Appointmentpage />
      </>
    ),
  },
  {
    path: "/records",
    element: (
      <>
        <MappingHeader />
        <RecordsLayout />
      </>
    ),
    children: [
      {
        index: true,
        element: <Navigate to="bookings" replace />,
      },
      {
        path: "profile",
        element: <Profilesectionpage />,
      },
      {
        path: "bookings",
        element: <Bookinglist />,
      },
      {
        path: "pets",
        element: <Petlisting />,
      },
      {
        path: "invoice",
        element: <Invoice />,
      },

      {
        path: "chats",
        element: <Chats />,
      },
      {
        path: "contact",
        element: <Contact />,
      },
      {
        path: "diary",
        element: <Diary />,
      },
    ],
  },

  {
    path: "/add-pet",

    element: (
      <>
        <MappingHeader />
        <Petsection />
      </>
    ),
  },
  {
    path: "/consentform/:consentToken",
    element: <ConsentForm />,
  },
  // Protected routes
  {
    element: <ProtectedRoute />,
    children: [
      { path: "/client", element: <Client /> },
      { path: "/editProfile", element: <EditProfile /> },
      { path: "/editprofile", element: <EditProfile /> },
      { path: "/Profilepage", element: <Profilesectionpage /> },
      { path: "/petListings", element: <PetListings /> },
      { path: "/invoice", element: <Invoice /> },
      { path: "/review", element: <Review /> },
      { path: "/chat", element: <Chatpage /> },
      { path: "/pet-details/:id", element: <PetDetails /> },
      { path: "/scheduling", element: <Scheduling /> },

      // new pages
      { path: "/profile", element: <ProfileCustomer /> },
    ],
  },
]);

function App() {
  return (
    <>
      <Provider store={store}>
          <ProfileProvider>
        <SearchProvider>
          <CartProvider>
            <RouterProvider router={router} />
            <ToastContainer />
          </CartProvider>
        </SearchProvider>
        </ProfileProvider>
      </Provider>
    </>
  );
}

export default App;
